import { render } from "./EntityTypesLegend.vue?vue&type=template&id=68a45173"
import script from "./EntityTypesLegend.vue?vue&type=script&lang=js"
export * from "./EntityTypesLegend.vue?vue&type=script&lang=js"

import "./EntityTypesLegend.vue?vue&type=style&index=0&id=68a45173&lang=scss"
script.render = render

export default script